const queryStringParameters = new URLSearchParams(location.search);
const isRevitClient = () => !!queryStringParameters.get("isRevitAddin");

export default isRevitClient;
